import React, {useState, useContext} from 'react';
import {useHistory} from 'react-router-dom'
import InvoiceRequest from "@formComponents/InvoiceRequest";
import PaypalBox from "@formComponents/PaypalBox";
import FormError from "@formComponents/FormError";
import * as Yup from "yup";
import {Formik, Form} from "formik";
import {useTranslation} from "react-i18next";
import store from "@formApp/store"

export default () => {
  const {t} = useTranslation();
  let history = useHistory();
  const {formValues, domainsList, transitions} = useContext(store);
  const [payment, setPayment] = useState('year');
  const selectedItem = domainsList.getSelected();
  const formEl = React.useRef(null);
  const {siteName, domain, entity, org, org_taxid, taxid, Nome, Cognome, nationality, nation, address, zip, city, prov, dial_code, phone, Email, Birth, paypalParams, dataId, transfer} = formValues.getAllValues();

  let initialValues = {
    invoice: formValues.getValue('invoice') || false,
    dataId: formValues.getValue('dataId'),
    paypalParams: paypalParams,
    invoice_rs: formValues.getValue('invoice_rs') || org || '',
    invoice_piva: formValues.getValue('invoice_piva') || '',
    invoice_company_cf: formValues.getValue('invoice_company_cf') || '',
    invoice_pec: formValues.getValue('invoice_pec') || '',
    invoice_recipient_code: formValues.getValue('invoice_recipient_code') || '',
    invoice_name: formValues.getValue('invoice_name') || Nome || '',
    invoice_surname: formValues.getValue('invoice_surname') || Cognome || '',
    invoice_addr: formValues.getValue('invoice_addr') || address || '',
    invoice_cap: formValues.getValue('invoice_cap') || zip || '',
    invoice_city: formValues.getValue('invoice_city') || city || '',
    invoice_prov: formValues.getValue('invoice_prov') || prov || '',
    invoice_cf: formValues.getValue('invoice_cf') || taxid || '',
    invoice_tel: formValues.getValue('invoice_tel') || phone || ''
  };
  let validationSchema = {
    invoice: Yup.boolean(),
    dataId: Yup.string().required(),
    invoice_rs: Yup.string().when('invoice', { is: true, then: Yup.string().required(t('L\'intestatario della fattura è obbligatorio')) }),
    invoice_piva: Yup.string().when('invoice', { is: true, then: Yup.string().matches(/^\d{11}$/, t('err_org_taxid')) }),
    invoice_company_cf: Yup.string().when('invoice', { is: true, then: Yup.string().matches(/^\d{11}$/, t('Il formato del codice fiscale della società non è valido')) }),
    invoice_pec: Yup.string().when('invoice', { is: true, then: Yup.string().email(t('La PEC non è valida')) }),
    invoice_recipient_code: Yup.string().when('invoice', { is: true, then: Yup.string().matches(/^[a-zA-Z0-9]{7}$/, t('Il formato del codice destinatario SdI non è valido')) }),
    invoice_name: Yup.string().when('invoice', { is: true, then: Yup.string().required(t('no_Nome')) }),
    invoice_surname: Yup.string().when('invoice', { is: true, then: Yup.string().required(t('no_Cognome')) }),
    invoice_addr: Yup.string().when('invoice', { is: true, then: Yup.string().required(t('no_address')) }),
    invoice_cap: Yup.string().when('invoice', { is: true, then: Yup.string().required(t('no_zip')) }),
    invoice_city: Yup.string().when('invoice', { is: true, then: Yup.string().required(t('no_city')) }),
    invoice_prov: Yup.string().when('invoice', { is: true, then: Yup.string().required(t('no_prov')) }),
    invoice_cf: Yup.string().when('invoice', { is: true, then: Yup.string().matches(/^[A-Z]{6}(\d\d)([A-EHLMPRST])(\d\d)[A-Z0-9]{4}[A-Z]$/, t('err_taxid')).uppercase().required(t('no_taxid')) }),
    invoice_tel: Yup.string().when('invoice', { is: true, then: Yup.string().required(t('no_phone')) }),
  };
  React.useEffect(() => {
    if (!domainsList.getSelected()) history.push('step-1');
  }, [domainsList, formValues]);
  React.useEffect(() => {        
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, []);

  const handleChange = () => {
    resetFields();
    history.push('step-1');
  };
  const handleBack = () => {
    formValues.setValue('dataId', null);
    formValues.setValue('paypalParams', null);
    transitions.setCurrent('step-back');
    history.goBack();
  };
  const handleToggle = () => {
    (payment === 'year') ? setPayment('month') : setPayment('year');
  };
  const resetFields = () => {
    formValues.setValue('dataId', null);
    formValues.setValue('paypalParams', null);
  };
  return (
    <>
      <header className="form-heading">
        <h2>{t('Scegli pagamento')}</h2>
      </header>
      <Formik
        initialValues={initialValues}
        validationSchema={Yup.object(validationSchema)}
        onSubmit={(values, { setSubmitting }) => {
          for (let key in values) {
            formValues.setValue(key, values[key]);
          }
          setSubmitting(false);
          return values
        }}
      >
        <Form className="domainRegistration" ref={formEl}>
          <div className="formSection--container form-summary">
          {(selectedItem.domain === '.it' && transfer != 1)
            ? <div className='formSection formGroup full' dangerouslySetInnerHTML={{__html: (entity === '1' || entity === '3') ? t('domain_it_summary_entity_1', formValues.getAllValues()) : t('domain_it_summary_entity_other', formValues.getAllValues())}} />
            : <>
                <div className="formSection formGroup">
                  <div className="formSection--title">{t('Nome dominio')}</div>
                  <p>www.{selectedItem.name}<strong>{selectedItem.domain}</strong></p>
                  <div className="formSection--title">{t('Dati del Registrante')}</div>
                  <div><strong>{t('Tipo di registrante')}:</strong> <span>{(entity === '1') ? t('Privato') : t('Società')}</span></div>
                  {entity !== '1' &&
                  <>
                    <div><strong>{t('Ragione Sociale')}:</strong> <span>{org}</span></div>
                    <div><strong>{t('Partita IVA')}:</strong> <span>{org_taxid}</span></div>
                  </>
                  }
                  <div><strong>{t('Nome')}:</strong> <span>{Nome}</span></div>
                  <div><strong>{t('Cognome')}:</strong> <span>{Cognome}</span></div>
                  <div><strong>{t('Anno di nascita')}:</strong> <span>{Birth}</span></div>
                </div>
                <div className="formSection formGroup">
                  <div className="formSection--title">{entity === '1' ? t('Residenza e recapiti') : t('Sede legale e recapiti')}</div>
                  <div><strong>{t('Nazione')}:</strong> <span>{nation}</span></div>
                  <div><strong>{t('Indirizzo')}:</strong> <span>{address}</span></div>
                  <div><strong>{t('CAP')}:</strong> <span>{zip}</span></div>
                  <div><strong>{t('Città')}:</strong> <span>{city}</span></div>
                  <div><strong>{t('Provincia/Stato')}:</strong> <span>{prov}</span></div>
                  <div><strong>{t('Email')}:</strong> <span>{Email}</span></div>
                  <div><strong>{t('Telefono')}:</strong> <span>+{dial_code} {phone}</span></div>
                </div>
              </>
          }
            <div className='formSection-data-edit'>
              <button type='button' className='alt-btn-link' onClick={handleBack}>
              <img className='formSection-data-edit-icon' src='/images/icon-edit.svg' />
                {t('Modifica Dati')}
              </button>
            </div>
          </div>
          <section className='formSection formInvoice'>
            <InvoiceRequest />
          </section>
          <div className='paymentWrapper'>
            <div className='paymentSwitch-wrapper'>
              <span style={{fontWeight: (payment === 'year') ? '700' : '400'}}>{t('Annuale')}</span>
              <input
                checked={(payment === 'month')}
                onChange={handleToggle}
                className="switch-checkbox"
                id='paymentSwitch'
                type="checkbox"
              />
              <label
                className="switch-label"
                htmlFor='paymentSwitch'
              >
                <span className='switch-button' />
              </label>
              <span style={{fontWeight: (payment === 'month') ? '700' : '400'}}>{t('Mensile')}</span>
            </div>
            {paypalParams &&
              <>
                <div className='paymentMethod'>
                  {(payment === 'year') && <span className='bestOffer'>{t('Migliore Offerta')}</span>}
                  {/*<div className='paymentMethod-header'>{(payment === 'year') ? t('Paga ogni anno') : t('Paga ogni mese')}</div>*/}
                  <div className="paymentMethod-body">
                    <div className='finalPrice'><strong>{paypalParams.pp_item_price[payment].display_price} &euro; </strong>{t(' + iva / mese')}</div>
                    {(payment === 'year')
                      ?
                        t('Unico pagamento di {{price}}€', { price: paypalParams.pp_item_price[payment].price_with_tax })
                      :
                        t('Prezzo con tasse incluse {{price}}€', { price: paypalParams.pp_item_price[payment].price_with_tax })
                    }
                  </div>
                </div>
                <PaypalBox payment={payment} />
                <FormError />
              </>
            }
          </div>
        </Form>
      </Formik>
    </>
  )
}